import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, StarRating} from '@optimaxdev/design-system';
import {Icon, Location} from '@optimaxdev/icons';
import {connect} from 'react-redux';

import {TYP_INFO_BLOCK} from 'constants/analytics/events/typ';
import {ApplicationStoreType} from 'desktop/store';

import {StatusBar} from '../statusBar/statusBar';

import s from './orderInfo.scss';

export type PropsType = {
    orderID: string;
    needPrescription: boolean;
};

/**
 * Order info for TYP
 *
 * @param {PropsType} props - component props
 * @constructor
 */
export const OrderInfo: React.FC<PropsType> = ({needPrescription, orderID}) => (
    <>
        <h2 className={s.title}>Order info</h2>
        <div className={s.orderInfo}>
            <span className={s.orderNumber} data-test-name="orderNumber" data-test-value={orderID}>
                Your order number is: {orderID}
            </span>
            <button
                onClick={() =>
                    sendDesktopAnalyticsEvent(
                        {...TYP_INFO_BLOCK, category: 'TYP'},
                        {
                            blockName: 'Order Tracking',
                            label: 'Clicked',
                        },
                    )
                }
                className={s.track}
                type="button"
            >
                <Icon className={s.icon} height={20} icon={Location} strokeWidth={1.5} width={14} />
                Track your order{' '}
                <a href="/tracking/search/" target="_blank">
                    here
                </a>
            </button>
        </div>
        <StatusBar needPrescription={needPrescription} />
        <div className={s.quality}>
            <StarRating color={Colors.richElectricBlue} rating={100} size={30} />
            Each order passes our 5-stripe testing to ensure the highest quality.
        </div>
    </>
);

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    needPrescription: state.successPage.order.needPrescription,
    orderID: state.successPage.order.incrementId,
});

export const OrderInfoConnected = connect(mapStateToProps)(OrderInfo);
